import { render, staticRenderFns } from "./TaxSummary.vue?vue&type=template&id=dfb9eeba&"
import script from "./TaxSummary.vue?vue&type=script&lang=js&"
export * from "./TaxSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports